module.exports = __webpack_public_path__ + "static/media/Agri Asset Stack - GBR Network - 21-03-2025 N.f438bdeb.png";